import Vue from 'vue'
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
Vue.use(Autocomplete)



// WEBPACK FOOTER //
// ./src/plugins/v-autocomplete.js